import { Platform } from "react-native";
/* ======== Components ========= */
import type { FABProps } from "react-native-paper";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import Box from "../Box";
import { FAB } from "../FAB";

type Props = {
	bottom?: number;
} & FABProps;

const BottomFab = ({ onPress, icon, label, bottom }: Props) => {
	const insets = useSafeAreaInsets();

	return (
		<Box
			style={{
				position: "absolute",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				right: 16,
				bottom: bottom || insets.bottom + (Platform.OS === "ios" ? 0 : 16),
			}}
		>
			<FAB
				onPress={onPress}
				style={{
					maxWidth: "100%",
				}}
				icon={icon}
				label={label!}
			/>
		</Box>
	);
};

export default BottomFab;
